import { createSelector } from 'reselect';

import { getUser } from './user.selectors';

export const getLeadAssigment = createSelector(getUser, ({ leadAssigment }) => leadAssigment);
